import { HandleData } from '@core/app/scripts/services/handle-data';
import { Utility } from '@core/app/scripts/services/utility';

export class WriteTransaction {
  transactionModel = null;
  TRANSACTION_BUFFER = 8;

  constructor(
    private $log: ng.ILogService,
    private handleData: HandleData,
    private utility: Utility,
  ) {}

  /*
   * A buffer transaction uses saves changes to the same transaction. This is different from a typical
   * transaction that is only saved once and never changed again
   * @param {Object} transaction the transaction object
   * @param {Function} success callback for success
   */
  buffer = (transaction, success, error) => {
    const t = angular.copy(transaction);

    if (transaction.buffer_id) {
      //Use existing buffer id
      t._id = transaction.buffer_id;
      delete t.buffer_id;
    } else {
      t._id = 'buffer_' + this.utility.uuid();
    }
    //Stamp the transaction with the correct type
    t.type = this.TRANSACTION_BUFFER;
    t.active = true;
    this.handleData.saveData(
      {
        resource: 'buffer',
      },
      t,
      (r) => {
        if (!r.data || r.data.length === 0) {
          this.$log.error(
            '[Buffer Transaction] Buffered transaction was not saved!',
          );
          return;
        }
        //send the callback method the buffer id
        if (success) {
          success(r.data[0]);
        }
      },
      () => {
        this.$log.error('[Buffer Transaction] Error saving to the buffer!');
      },
      {
        customError: true,
      },
    );
  };

  /*
   * Set the buffered transaction as inactive
   * @param {String} buffer_id
   */
  bufferInactive = (buffer_id, success) => {
    const bufferSuccess = (r) => {
      if (!r.data || r.data.length === 0) {
        this.$log.error(
          '[Buffer Transaction] Buffered transaction not deactivated!',
        );
        return;
      }
      //send the callback method the buffer id
      if (success) {
        success(r.data[0]);
      }
    };
    const error = () => {
      this.$log.error('[Buffer Transaction] Error saving to the buffer!');
    };
    this.handleData.updateData(
      {
        resource: 'buffer',
      },
      {
        _id: buffer_id,
      },
      {
        $set: {
          active: false,
        },
      },
      bufferSuccess,
      error,
      {
        'set-fields': true,
        customError: true,
      },
    );
  };
}

/*
 * Service to write and get transaction objects
 */
angular
  .module('posApp')
  .service(
    'writeTransaction',
    ($log: ng.ILogService, handleData: HandleData, utility: Utility) => {
      return new WriteTransaction($log, handleData, utility);
    },
  );
